import { render, staticRenderFns } from "./ProductChangeStatusImportExcel.vue?vue&type=template&id=22469ce0&scoped=true"
import script from "./ProductChangeStatusImportExcel.vue?vue&type=script&lang=js"
export * from "./ProductChangeStatusImportExcel.vue?vue&type=script&lang=js"
import style0 from "./ProductChangeStatusImportExcel.vue?vue&type=style&index=0&id=22469ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22469ce0",
  null
  
)

export default component.exports